import {Directive, inject, Input, OnDestroy, TemplateRef, ViewContainerRef} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {filter, map, Observable, Subscription} from 'rxjs';
import {LensSetting, LensSettingsOptions} from 'src/app/lenses/shared/model/lens-setting';
import {selectActiveUserLens} from 'src/app/core/store/active-user/active-user.selector';

@Directive({
  selector: '[userHasLens]',
  standalone: true,
})
export class UserHasLensDirective implements OnDestroy {
  private store$ = inject(Store);
  private viewContainer = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef<unknown>);

  userLens$: Observable<LensSetting> = this.store$.pipe(
    select(selectActiveUserLens),
    map(lens => lens?.settings)
  );
  private subscription: Subscription = new Subscription();
  private hasView = false;

  @Input() set userHasLens(permissionKey: LensSettingsOptions) {
    this.subscription.unsubscribe();

    this.subscription = this.userLens$.pipe(filter(userLens => !!userLens)).subscribe(userLens => {
      const isActive = userLens?.[permissionKey]?.active;

      if (isActive && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!isActive && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
